
import { Component, Vue, Prop } from "vue-property-decorator";

import akt_routes from "@/api/routes/akt";
import users_routes from "@/api/routes/users";

import UserUser from "@/models/user/user";
import { EAdmissionPermission } from "@/models/admission/permission";

@Component({
  name: "CAktReviewDelegation"
})
export default class CAktReviewDelegation extends Vue {
  @Prop({ required: true }) public assignment_user_workplace_id!: string;

  public responsibles: UserUser[] = [];
  public selected_responsible_id: string | null = null;
  public selected_responsible_errors: string | null = null;

  protected async created() {
    await this.loadResponsibles();
  }

  private async loadResponsibles() {
    return this.$api
      .get(users_routes.users, {
        params: {
          paginate: false,
          exclude_current_user: true,
          only_my: false,
          permission_id: EAdmissionPermission.AKT_COMPLETED
        }
      })
      .then(({ data: res }: { data: { users: UserUser[] } }) => {
        this.responsibles = res.users;
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  public async delegateAkt() {
    this.selected_responsible_errors = null;

    if (!this.selected_responsible_id) {
      this.selected_responsible_errors = "Выберите сотрудника для проверки ЕПЗ";

      return;
    }

    return this.$api
      .post(
        akt_routes.post_workplace_delegate(this.assignment_user_workplace_id),
        {
          responsible_id: this.selected_responsible_id
        }
      )
      .then(() => {
        this.$emit("onVisited", true);
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  public hideDelegationModal() {
    this.$emit("close", true);
  }
}
